module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/container-da96490b4759a08c2be93d4e0c3db544.svg";